import { connect } from 'react-redux';
import InvoiceLineEditorSlidingPanel from './InvoiceLineEditorSlidingPanel';
import { fetchInvoiceJurisdictionalBreakdown } from 'redux/invoiceDetail/InvoiceDetailActions';
import { fetchInvoiceById } from 'redux/invoices/InvoicesActions';
import { bindActionCreators } from "redux";

const mapStateToProps = ({ invoices }) => ({
  invoiceData: invoices.invoice
});

const mapDispatchToProps = dispatch => ({
  invoicesActions: bindActionCreators({ fetchInvoiceJurisdictionalBreakdown, fetchInvoiceById }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceLineEditorSlidingPanel);



// WEBPACK FOOTER //
// ./src/components/viewTransactions/viewTransactionsGrid/c/invoiceLinesSlidingPanel/invoiceLinesDetail/c/invoiceLineEditor/InvoiceLineEditorSlidingPanelConnector.js